import React from "react";
import _ from "lodash";
import { connect } from "formik";
import num from "numeral";
import { MoneyInput } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelMoneyInput = ({ label, fieldName, placeholder, formik, isDisabled, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{num(val).format("$0,0")}</ViewOnlyDiv>}
      {!isDisabled && <MoneyInput
        fullWidth
        fieldName={fieldName}
        placeholder={placeholder}
        {...otherProps}
      />}
    </LateralField>
  );
};
export default connect(SideLabelMoneyInput);
